import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The Reset (left) / Search (right) row under a list filter. Content projected between them sits
 * beside Reset (stock: the CSV export and "show totals"). Both buttons are `type="button"`, so Enter
 * in a field never clicks one; the host's own Enter-to-search handles that.
 *
 * Example: `<app-filter-actions (resetFilters)="reset()" (searchFilters)="searchGesture($event)"></app-filter-actions>`
 */
@Component({
  selector: 'app-filter-actions',
  templateUrl: './filter-actions.component.html',
  styleUrls: ['./filter-actions.component.scss'],
})
export class FilterActionsComponent {
  @Input() searchDisabled = false;
  @Output() resetFilters = new EventEmitter<void>();
  /** Emits the click, which the host hands to its search gesture. */
  @Output() searchFilters = new EventEmitter<Event>();
}
